<div>
  <div *ngFor="let contact of joinedContacts">
    <p class="email-types-header tw-font-semibold">{{ contact.first }} {{ contact.last }}</p>
    <button
      [ngClass]="{'email-type-btn': !contact.disabled}"
      mat-menu-item
      [disabled]="(contact.disabled || !contact.email)"
      (click)="handleAddRecipient(contact)"
      data-cy="email-select-contact">
      <span [ngClass]="{'disabled-contact': (contact.disabled || !contact.email)}">
        {{ contact.email ?? 'No email address on file.' }}
      </span>
    </button>
  </div>
  <div>
    <!-- Add New Contacts -->
    <p class="email-types-header tw-font-semibold">More Contacts</p>
    <button
      class="email-type-btn"
      mat-menu-item
      (click)="handleLaunchAddNewContactModal()"
      data-cy="email-add-new-contact">
        Add New
    </button>
  <div>
    <!-- Lendion Emails -->
    <button
      class="email-type-btn"
      mat-menu-item
      (click)="launchLendioDirectory()">
        Lendio Directory
    </button>
  </div>
</div>
